/* global Blockly */
import React from 'react';

function defineBlock() {
    return {
        init: function(){
            this.appendValueInput('FIRST')
                .setCheck('Date');
            this.appendDummyInput()
                .appendField('is')
                .appendField(new Blockly.FieldDropdown([['before', '<'], ['after', '>'], ['same date as', '==']]), 'COMPARISON');
            this.appendValueInput('SECOND')
                .setCheck('Date');
            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, 'Boolean');
            this.setOutputShape(Blockly.OUTPUT_SHAPE_HEXAGONAL);
            this.setColour(Blockly.Msg.DATES_HUE);
            this.setTooltip('Compare two dates');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#dates_section`);
        }
    }
}

function defineGenerator() {
    return function(block) {
        const funcName = Blockly.JavaScript.provideFunction_('toDate', [
            'function ' + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + '(s) {',
            's =  new Date(s);',
            's.setHours(0);',
            's.setMinutes(0);',
            's.setSeconds(0);',
            's.setMilliseconds(0);',
            'return s',
            '}'
        ]);

        const first = `${funcName}(${Blockly.JavaScript.valueToCode(block, 'FIRST', Blockly.JavaScript.ORDER_NONE)})`;
        const second = `${funcName}(${Blockly.JavaScript.valueToCode(block, 'SECOND', Blockly.JavaScript.ORDER_NONE)})`;
        const comparison = block.getFieldValue('COMPARISON');
        const code = `((${first}-${second})${comparison}0)`;
        return [code, Blockly.JavaScript.ORDER_ATOMIC];
    }
}

export const BLOCK_NAME = 'date_is_before_v3';

const DateIsBefore = function () {
    const name = BLOCK_NAME;
    DateIsBefore.blockName = name;

    Blockly.Blocks[name] = defineBlock();
    Blockly.JavaScript[name] = defineGenerator();

    return (
        <block type={name}>
            <value name='SECOND'><shadow type='date'/></value>
        </block>
    )
}

export default DateIsBefore